import { render, staticRenderFns } from "./ProjectShowBlocksTab.vue?vue&type=template&id=0a2c831a"
import script from "./ProjectShowBlocksTab.vue?vue&type=script&lang=ts"
export * from "./ProjectShowBlocksTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports